import {
	applyEoGREProfileFilter,
	focusEoGREProfile,
	openEoGREProfileSection,
} from './adapter';
import {
	openEoGREProfileCreateModal,
	openEoGREProfileDeleteModal,
	openEoGREProfileEditModal,
} from './modal';
import {resolveEoGREProfiles} from './resolver';

/**
 * EoGRE profiles.
 *
 * EoGRE profiles under Global Profiles. Named eogre_profile so
 * the bare word still answers as the Site and SSID field.
 *
 * Declares no fields: the Add and Edit forms are not mapped, so the agent
 * finds a profile and opens the form rather than filling it in. Delete
 * opens the confirmation and stops - the person presses the button.
 */
const eogreProfilePlugin = {
	id: 'eogre_profile',
	version: 1,
	commandVersion: 1,
	resource: 'eogre_profile',
	operations: ['options', 'list', 'search', 'create', 'edit', 'delete'],
	dependencies: {
		plugins: ['canvas.navigation'],
		destinations: ['profile.dashboard'],
	},
	sections: {
		'profile.eogre_profiles': openEoGREProfileSection,
	},
	resolvers: {
		eogre_profile: resolveEoGREProfiles,
	},
	filters: {
		eogre_profile: (command) => applyEoGREProfileFilter(command.params?.query),
	},
	focusHandlers: {
		eogre_profile: (command) => focusEoGREProfile(command.params?.entity_id),
	},
	modals: {
		'eogre_profile.create': openEoGREProfileCreateModal,
		'eogre_profile.edit': openEoGREProfileEditModal,
		'eogre_profile.delete': openEoGREProfileDeleteModal,
	},
};

export default eogreProfilePlugin;
